import { ShopType } from "@/types/shop";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface ShopState {
  shopId: number | null;
  shopDomain: string;
  currency: string;
  shopType: ShopType;
  shopFavicon: string;
  shopName: string;
  setShopId: (id: number) => void;
  setShopDomain: (url: string) => void;
  setCurrency: (currency: string) => void;
  setShopType: (shopType: ShopType) => void;
  setShopName: (name: string) => void;
  setShopFavicon: (favicon: string) => void;
}

export const useShopStore = create<ShopState>()(
  persist(
    (set) => ({
      shopId: null,
      shopDomain: "",
      currency: "",
      shopType: "SHOPIFY",
      shopName: "",
      shopFavicon: "",
      setShopId: (id: number) => set({ shopId: id }),
      setShopDomain: (url: string) => set({ shopDomain: url }),
      setCurrency: (currency: string) => set({ currency }),
      setShopType: (shopType: ShopType) => set({ shopType }),
      setShopName: (name: string) => set({ shopName: name }),
      setShopFavicon: (favicon: string) => set({ shopFavicon: favicon }),
    }),
    {
      name: "shop-storage",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
